import React from "react";
import CloseIcon from "@mui/icons-material/Close";
import { formattedPrice } from "../../utils";
import { useDispatch } from "react-redux";
import { fetchRemoveToCartItem } from "../../actions/global";
import { Link } from "react-router-dom";

function formatUrlString(inputString) {
  // Pretvara sva velika slova u mala
  const lowercaseString = inputString.toLowerCase();

  // Zamjenjuje sve razmake i specijalne karaktere sa -
  const formattedString = lowercaseString
    .replace(/[^\w\s]/gi, "")
    .replace(/\s+/g, "-");

  return formattedString;
}

const CartModalItem = ({ item, key, closeModal, isRemove = true }) => {
  const dispatch = useDispatch();

  const removeCartItem = () => {
    const dataValue = {
      productId: item?.id,
      quantity: item?.quantity,
    };

    dispatch(fetchRemoveToCartItem(dataValue));
  };

  return (
    <div className="cart-modal-item">
      <div className="cart-modal-item-text">
        <div className="cart-modal-item-title">
          <Link
            to={`/proizvod/${formatUrlString(item.name)}/${item.id}`}
            onClick={closeModal}
          >
            {item.name}
          </Link>
        </div>
        <div className="cart-modal-item-price">
          {item?.quantity} x {formattedPrice(item?.fixPrice || item?.cashPrice)}{" "}
          RSD
        </div>
      </div>
      <div className="cart-modal-item-image">
        <img src={item?.images?.[0]} className="img-fluid" alt="UP-IT" />
        {isRemove && (
          <div
            className="cart-modal-item-remove"
            onClick={() => removeCartItem()}
          >
            <CloseIcon />
          </div>
        )}
      </div>
    </div>
  );
};

export default CartModalItem;
